import type { TRequestStage } from '@/shared/types/leasing-request.types';

export const LEASING_REQUEST_STAGE_ORDER: TRequestStage[] = [
  'decision',
  'signing',
  'payment',
  'registration',
  'preparing',
  'issue'
];

export const WAITING_OF_FINANCING_STATUS_CODE = 'waiting_of_financing';

export const LEASING_DOCUMENTS_AVAILABLE_STAGES: TRequestStage[] = [
  'signing',
  'payment',
  'registration',
  'preparing',
  'issue',
  'contract'
];
